import React, { Component } from "react";

import {
  Banner,
  Card,
  Modal,
  Page,
  Pagination,
  Select,
  TextContainer,
  FooterHelp,
  Link,
  Subheading,
  Label,
  Badge,
  Button,
  Tabs,
  Stack,
  Icon,
  TextField,
  EmptyState,
  Checkbox,
  DisplayText,
  ProgressBar,
  Tooltip,
} from "@shopify/polaris";
import { requests } from "../../services/request";
import ReactJson from "react-json-view";
import { notify } from "../../services/notify";
import { NavLink } from "react-router-dom";
import SmartDataTable from "../../shared/smartTable";
import { isUndefined } from "util";
import { paginationShow } from "../../shared/static-functions";
import ReadMoreReact from "read-more-react";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.slim.min";
import "popper.js/dist/umd/popper.min";
import "bootstrap/dist/js/bootstrap.min";

// import Grid from "../../shared/react-data-grid/grid";
import Grid from "../../Subcomponents/Aggrid/grid";
import {
  conditioncheck,
  createDemoRows,
} from "../../shared/react-data-grid/createDemoRows";
import Filter from "../../shared/react-data-grid/filter";
import NumericFilter from "../../shared/react-data-grid/filters/numericFilter";
import {
  extractValuesfromRequest,
  ebayId,
  filterCondition,
  filterOptions,
  getFilterforRequest,
  getpaginationInfo,
  getTabSelectedFilter,
  gridPropColumns,
  orderlistTabs,
  pageSizeOptionOrders,
} from "./orderHelper";
import { getorders } from "../../APIrequests/ordersAPI";
import { prepareChoiceoption } from "../../Subcomponents/Aggrid/gridHelper";
import LoadingOverlay from "react-loading-overlay";
import CustomNoRowsOverlay from "../../Subcomponents/Aggrid/CustomNoRowsOverlay";
import { QuestionMarkMinor } from "@shopify/polaris-icons";
import { Doughnut } from "react-chartjs-2";

let gridApi = "";

const defaultData = {
  width: 200,
  filterable: true,
  editable: false,
  sortable: false,
  resizable: true,
  draggable: false,
  attachment: false,
};
const defaultParams = {
  rowHeight: 50,
  minHeight: window.innerHeight - 170,
  headerRowHeight: 50,
  headerFiltersHeight: 50,
  enableCellSelect: false,
};

const {
  DraggableHeader: { DraggableContainer },
} = require("react-data-grid-addons");

class NewOrders extends Component {
  grid_loader = false;

  filters = {
    column_filters: {},
  };
  gridSettings = {
    activePage: 1,
    count: 10,
  };
  pageLimits = [
    { label: 20, value: "20" },
    { label: 40, value: "40" },
    { label: 60, value: "60" },
    { label: 80, value: "80" },
    { label: 100, value: "100" },
  ];
  massActions = [
    // {label: 'Sync with Shopify', value: 'syncshopify'},
    { label: "Remove for app", value: "removeorderapp", disabled: true },
    { label: "Sync shipment", value: "syncshipment", disabled: false },
  ];
  orderListTabs = [
    {
      id: "Unfulfilled",
      content: "Unfulfilled",
      accessibilityLabel: "Unfulfilled",
      link: "",
      panelID: "Unfulfilled",
    },
    {
      id: "Fulfilled",
      content: "Fulfilled",
      accessibilityLabel: "Fulfilled",
      link: "",
      panelID: "Fulfilled",
    },

    {
      id: "Failed",
      content: "Failed",
      accessibilityLabel: "Failed",
      link: "",
      panelID: "Failed",
    },
    {
      id: "Cancelled",
      content: "Cancelled",
      accessibilityLabel: "Cancelled",
      link: "",
      panelID: "Cancelled",
    },
    {
      id: "PartialFulfilled",
      content: "Partial Fulfilled",
      accessibilityLabel: "PartialFulfilled",
      link: "",
      panelID: "PartialFulfilled",
    },
    /*,
         {
         id: 'Sandbox',
         content: 'Sandbox',
         accessibilityLabel: 'Sandbox',
         link: '',
         panelID: 'Sandbox'
         }*/
  ];

  visibleColumns = [
    "source_order_id",
    "shopify_order_name",
    "imported_at",
    "customer_name",
    "fulfillment",
  ];
  customButton = [];
  hideFilters = [
    "imported_at" /*,'status_view','qty','total_price'*/,
    "target_order_id" /*,'customer_name'*/,
    "fulfillment",
  ];
  columnTitles = {
    id: {
      title: "ID",
      sortable: true,
    },
    source_order_id: {
      title: "eBay order ID",
      sortable: true,
    },
    shopify_order_name: {
      title: "Shopify Order Name",
      sortable: true,
    },
    customer_name: {
      title: "Customer Name",
      sortable: true,
    },
    /*   qty: {
               title: 'Quantity',
               sortable: true,
               type: 'int'
           },
           total_price: {
               title: 'Price',
               sortable: true,
               type: 'int'
           },
           total_weight: {
               title: 'Weight',
               sortable: true
           },
           total_tax: {
               title: 'Tax',
               sortable: true
           },
           currency: {
               title: 'currency',
               sortable: true
           },*/
    target_order_id: {
      title: "Shopify order ID",
      sortable: true,
      type: "react",
    },
    fulfillment: {
      title: "Fulfillment",
      sortable: true,
      type: "react",
    },
    /*   status_view: {
               title: 'Status',
               sortable: true,
               type:'react'
           },*/
    imported_at: {
      title: "Imported At",
      sortable: true,
    },
  };
  filtersChanged = false;

  column = [
    {
      key: "check",
      name: (
        <Checkbox
          id={"all"}
          checked={false}
          onChange={this.allSelector.bind(this, "all_selector")}
        />
      ),
      frozen: true,
      editable: false,
      width: 50,
      sortable: false,
      draggable: false,
      filterable: false,
    },
    {
      key: "source_order_id",
      name: "eBay order ID",
      frozen: true,
      editable: false,
      width: 200,
      filterable: true,
      filterRenderer: Filter,
      sortable: false,
    },
    {
      key: "shopify_order_name",
      name: "Shopify Order Name",
      frozen: false,
      editable: false,
      width: 250,
      filterRenderer: Filter,
      filterable: true,
      sortable: false,
      attachment: true,
    },
    {
      key: "fulfillment",
      name: "Fulfillment",
      frozen: false,
      editable: false,
      width: 250,
      filterable: false,
      sortable: false,
    },
    {
      key: "customer_name",
      name: "Customer Name",
      frozen: false,
      editable: false,
      width: 250,
      filterRenderer: Filter,
      filterable: true,
      sortable: false,
    },
    {
      key: "importedAt",
      name: "Imported At",
      frozen: false,
      editable: false,
      width: 250,
      filterable: false,
      sortable: false,
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      syncOrderShipmentBtnLoader: false,
      selectedRows: [],
      toolbar_suffix: "Order(s)",
      order: [],
      rows: [],
      delete_order_ids: [],
      showdeleteOrderModal: false,
      orderError: false,
      orderErrorJson: false,
      totalPage: 0,
      selectedProducts: [],
      selectedTab: 0,
      isSandbox: false,
      pagination_show: 0,
      showLoaderBar: true,
      hideLoader: false,
      line_item_collapsible: "",
      tempOrderData: [],
      AllSelect: false,
      syncwithShopify: false,
      removeorderapp: false,
      syncshipment: false,
      tempSelectedProducts: [],
      source_shop_id: 0,
      sync_order_from: 5,
      showSyncOrders: false,
      columns: this.column.map((c) => ({ ...defaultData, ...c })),
      visibleColumns: {
        check: 1,
        source_order_id: 1,
        shopify_order_name: 1,
        importedAt: 1,
        customer_name: 1,
        fulfillment: 1,
      },
      pagination: {
        page: 1,
        totalNumberOfPages: 0,
        totalNumberOfProducts: 0,
        totalNumberOfItems: 0,
        pageSize: 25,
      },
      credits_info: {
        order: {
          available: 0,
          total: 0,
          percent: 0,
        },
      },
      showMassAction: false,
      massAction: [
        // {label: 'Sync with Shopify', value: 'syncshopify'},
        { label: "Remove for app", value: "removeorderapp", disabled: true },
        { label: "Sync shipment", value: "syncshipment", disabled: false },
      ],
      preparedFilter: {},
      checkbox: {},
      All_Selected: false,
      selected_count: 0,

      // utkarsh
      tabs: orderlistTabs,
      columnsAG: gridPropColumns(
        this.incellElement.bind(this),
        window.innerWidth
      ),
      rowsAG: [],
      paginationProps: {
        pageSizeOptions: pageSizeOptionOrders,
        activePage: 1,
        pageSize: pageSizeOptionOrders[0],
        pages: 0,
        totalrecords: 0,
      },
      tabfilters: {},
      filtersProps: {
        attributeoptions: [],
        filters: [],
        filterCondition: filterCondition,
      },
      frameworkComponents: {
        customNoRowsOverlay: CustomNoRowsOverlay,
      },
      noRowsOverlayComponent: "customNoRowsOverlay",
      noRowsOverlayComponentParams: {
        noRowsMessageFunc: () => (
          <EmptyState
            heading="No Orders Found"
            // image="https://cdn.shopify.com/s/assets/admin/empty-states-fresh/emptystate-abandoncheckout-de95c7af243bfbc1a127a7bd1a6a9b7a5769ddc295a303268fdf26913f16801c.svg"
          ></EmptyState>
        ),
      },
    };
    // this.getOrders();
    // this.getOrdersNew();
    this.getSourceShopId();
  }

  getStatus = (status) => {
    switch (status) {
      case "pendingShipment":
        return (
          <Badge status={"info"} progress="partiallyComplete">
            Unfulfilled
          </Badge>
        );
        break;
      case "canceled":
        return (
          <Badge status={"warning"} progress="complete">
            Canceled
          </Badge>
        );
        break;
      case "failed":
        return (
          <Badge status={"warning"} progress="complete">
            Failed
          </Badge>
        );
        break;
      case "fulfilled":
        return (
          <Badge status={"success"} progress="complete">
            Fulfilled
          </Badge>
        );
        break;
      case "inProgress":
        return (
          <Badge status={"attention"} progress="incomplete">
            Unfulfilled
          </Badge>
        );
        break;
      default:
        return (
          <Badge status={"attention"} progress="partiallyComplete">
            {status}
          </Badge>
        );
    }
  };

  tabSelected(tabs) {
    let tabfilters = {};
    let { paginationProps } = this.state;
    paginationProps["pageSizeOptions"] = pageSizeOptionOrders;
    paginationProps["activePage"] = 1;
    paginationProps["pageSize"] = pageSizeOptionOrders[0];
    paginationProps["pages"] = 0;
    paginationProps["totalrecords"] = 0;
    let tabselected = orderlistTabs.filter(
      (tabOrder, tabIndex) => tabIndex === tabs
    );
    if (tabselected.length) {
      tabselected = tabselected[0]["type"];
      tabfilters = { ...getTabSelectedFilter(tabselected) };
    }
    this.setState(
      { selectedTab: tabs, tabfilters, selectedRows: [], paginationProps },
      () => {
        // this.getProducts();
        let event = this.state.selectedTab;
        if (event === 2 || event === 0 || event === 1 || event === 4) {
          // console.log('event', event)
          this.state.massAction = [
            // {label: 'Sync with Shopify', value: 'syncshopify'},
            // { label: 'Remove for app', value: 'removeorderapp', disabled: false },
            { label: "Sync shipment", value: "syncshipment", disabled: false },
          ];
          if (event === 2) {
            this.state.massAction = [
              // {label: 'Sync with Shopify', value: 'syncshopify'},
              {
                label: "Remove for app",
                value: "removeorderapp",
                disabled: false,
              },
              {
                label: "Sync shipment",
                value: "syncshipment",
                disabled: false,
              },
            ];
          }
        } else {
          this.state.massAction = [
            // {label: 'Sync with Shopify', value: 'syncshopify'},
            {
              label: "Remove for app",
              value: "removeorderapp",
              disabled: true,
            },
            { label: "Sync shipment", value: "syncshipment", disabled: true },
          ];
        }
        this.updateState();
        this.getOrdersNew();
      }
    );
  }

  componentDidMount() {
    this.tabSelected(0);
    this.prepareFilters();

    this.getServiceCredits();
    document.title = "Fetch the orders received on eBay - CedCommerce";
    document.description =
      "Order section helps you to keep a track of your orders (Fulfilled/Unfulfilled/Failed/Cancelled). It updates you about each new order received on eBay.";
    if (!document.title.includes(localStorage.getItem("shop_url"))) {
      document.title += !isUndefined(localStorage.getItem("shop_url"))
        ? " " + localStorage.getItem("shop_url")
        : "";
    }
  }

  getServiceCredits() {
    requests
      .getRequest(
        "frontend/app/getServiceCredits",
        { service_code: "ebay_order_sync" },
        false,
        true
      )
      .then((ordercredits) => {
        if (ordercredits.success) {
          let orderObj = {
            available: ordercredits.data.available_credits,
            total:
              ordercredits.data.available_credits +
              ordercredits.data.total_used_credits,
            percent:
              (ordercredits.data.available_credits /
                (ordercredits.data.available_credits +
                  ordercredits.data.total_used_credits)) *
              100,
          };
          this.state.credits_info.order = Object.assign({}, orderObj);
        }
        this.setState(this.state);
      });
  }

  filterString(value) {
    let tempObj = {};
    let filter = "";
    Object.keys(value).forEach((data) => {
      if (value[data].value !== "") {
        tempObj = {
          ...tempObj,
          ...{
            [`filter[${data}][${value[data].operator}]`]: value[data].value,
          },
        };
        // filter += '&filter[' + data + '][' + value[data].operator + ']=' + value[data].value;
      }
    });
    return tempObj;
    // return filter;
  }
  handleToggleClick = (line_item_collapsible) => {
    if (this.state.line_item_collapsible === line_item_collapsible) {
      this.setState({ line_item_collapsible: "" });
    } else {
      this.setState({ line_item_collapsible: line_item_collapsible });
    }
    const orders = this.modifyProductsData(
      this.state.tempOrderData,
      line_item_collapsible
    );
    this.setState({ order: orders });
  };
  modifyProductsData(data, line_item_collapsible) {
    let products = [];
    let Hash_Remove;

    for (let i = 0; i < data.length; i++) {
      let rowData = {};
      let rows = [];
      rowData["id"] = data[i]._id;
      Object.keys(data[i].line_items).forEach((key, index) => {
        rows.push([
          data[i].line_items[key]["mpn"] !== null
            ? data[i].line_items[key]["mpn"]
            : " - ",
          data[i].line_items[key]["quantity_ordered"],
          data[i].line_items[key]["total_price"],
        ]);
      });
      rowData["source_order_id"] =
        /* <div onClick={this.operations.bind(this,data[i]._id,'button_1')} style={{cursor:"pointer"}}>{
         */ data[i].source_order_id; /*}</div>*/
      /*rowData['qty'] = data[i]['qty'];
            rowData['total_price'] = data[i].total_price;
            rowData['total_weight'] = data[i].total_weight;
            rowData['total_tax'] = data[i]['total_tax'];
            rowData['currency'] = data[i]['currency'];*/
      rowData["customer_name"] =
        data[i].client_details.name !== "" ? (
          data[i].client_details.name
        ) : (
          <div className="w-100 text-center">
            <Icon source="subtract" />
          </div>
        );
      if (isNaN(parseInt(data[i]["target_order_id"]))) {
        rowData["target_order_id"] = (
          <div className="w-100 text-center">
            <Icon source="subtract" />
          </div>
        );
      } else {
        rowData["target_order_id"] = (
          <Label>{data[i]["target_order_id"]}</Label>
        );
      }
      if (isUndefined(data[i]["shopify_order_name"])) {
        rowData["shopify_order_name"] = (
          <React.Fragment>
            {/*  <FontAwesomeIcon icon={faMinus} size="2x" color="#cccccc"/>*/}
            <Icon source="subtract" />
            <div
              className="w-100"
              onClick={this.handleToggleClick.bind(this, i)}
            >
              <h2 style={{ color: "#868686", cursor: "pointer" }}>
                Order ID - {data[i]["target_order_id"]}
              </h2>
              {line_item_collapsible === i &&
                this.state.line_item_collapsible !== i && (
                  <Card>
                    <table className="table table-responsive-lg">
                      <tr>
                        <th> Mpn </th>
                        <th> Quantity </th>
                        <th> Price </th>
                      </tr>
                      {rows.map((e) => (
                        <tr>
                          <td>
                            {" "}
                            {
                              <div onClick={(e) => e.stopPropagation()}>
                                {" "}
                                <ReadMoreReact
                                  text={e[0]}
                                  min={20}
                                  ideal={20}
                                  max={20}
                                />
                              </div>
                            }
                          </td>
                          <td> {e[1]} </td>
                          <td> {e[2]} </td>
                        </tr>
                      ))}
                    </table>
                  </Card>
                )}
            </div>
          </React.Fragment>
        );
      } else {
        Hash_Remove = data[i]["shopify_order_name"];
        rowData["shopify_order_name"] = (
          <React.Fragment>
            <div onClick={this.handleToggleClick.bind(this, i)}>
              {Hash_Remove}
              <h2 style={{ color: "#868686", cursor: "pointer" }}>
                Order ID - {data[i]["target_order_id"]}
              </h2>
              {line_item_collapsible === i &&
                this.state.line_item_collapsible !== i && (
                  <Card>
                    <table className="table table-responsive-lg">
                      <tr>
                        <th> Mpn </th>
                        <th> Quantity </th>
                        <th> Price </th>
                      </tr>
                      {rows.map((e) => (
                        <tr>
                          <td>
                            {" "}
                            {
                              <div onClick={(e) => e.stopPropagation()}>
                                {" "}
                                <ReadMoreReact
                                  text={e[0]}
                                  min={20}
                                  ideal={20}
                                  max={20}
                                />
                              </div>
                            }
                          </td>
                          <td> {e[1]} </td>
                          <td> {e[2]} </td>
                        </tr>
                      ))}
                    </table>
                  </Card>
                )}
            </div>
          </React.Fragment>
        );
      }
      rowData["imported_at"] =
        /*<div onClick={this.operations.bind(this,data[i]._id,'button_1')} style={{cursor:"pointer"}}>{
         */ new Date(data[i].created_at).toLocaleDateString(); /*}</div>*/
      // if ( !isUndefined(data[i]['fulfillments'])
      //     && typeof data[i]['fulfillments'] === 'object'
      //     && Object.keys(data[i]['fulfillments']).length > 0 ) {
      //     rowData['status_view']=<div onClick={this.operations.bind(this,data[i]._id,'button_1')} style={{cursor:"pointer"}}>{
      //         this.getStatus('fulfilled')}</div>
      // } else {
      //     rowData['status_view'] =<div onClick={this.operations.bind(this,data[i]._id,'button_1')} style={{cursor:"pointer"}}>{
      //         this.getStatus(data[i]['status'])}</div>
      // }
      if (
        data[i]["source_order_id"] !== "" &&
        data[i]["target_order_id"] === ""
      ) {
        data[i]["status"] = "failed";
      }
      rowData["fulfillment"] = this.getStatus(data[i]["status"]);
      products.push(rowData);
    }
    return products;
  }
  operations = (data, event) => {
    switch (event) {
      default:
        this.redirect("/panel/orders/view?id=" + data["id"]);
        break;
    }
  };

  updateState() {
    const state = this.state;
    this.setState(state);
  }

  feildsChange(key, value) {
    var re = /^[0-9\b]+$/;
    if (value == "" || re.test(value)) {
      if (value >= 0 && value <= 30) {
        this.state[key] = value;
        this.updateState();
      }
    }
  }

  renderSyncOrderModal() {
    return (
      <div>
        <Modal
          open={this.state.showSyncOrders}
          onClose={() => {
            this.state.showSyncOrders = false;
            this.state.sync_order_from = 5;
            this.updateState();
          }}
          title="Sync orders"
        >
          <Modal.Section>
            <Stack vertical={true} distribution={"center"} alignment={"center"}>
              <p>You are about to perform Order sync</p>
              <TextField
                key={"Sync orders from "}
                value={this.state.sync_order_from}
                placeholder={""}
                error={
                  this.state.sync_order_from < 0 ||
                  this.state.sync_order_from > 30
                    ? "*incorrect input"
                    : ""
                }
                type={"number"}
                label={
                  "Specify number of days(0-30) for which you want your order to be synced"
                }
                onChange={this.feildsChange.bind(this, "sync_order_from")}
              />
              <Button
                disabled={
                  this.state.sync_order_from === "" ||
                  this.state.sync_order_from < 0 ||
                  this.state.sync_order_from > 30
                }
                onClick={this.orderSync.bind(this)}
                primary
              >
                Sync
              </Button>
            </Stack>
          </Modal.Section>
        </Modal>
      </div>
    );
  }

  deleteOrderIds() {
    requests
      .postRequest("ebayV1/delete/deleteOrder", {
        order_ids: this.state.delete_order_ids,
      })
      .then((data) => {
        if (data.success) {
          notify.success(data.message);
        } else {
          notify.error(data.message);
        }
        this.state.showdeleteOrderModal = false;
        this.state.delete_order_ids = [];
        this.updateState();
      });
  }

  renderdeleteOrderIdsModal() {
    return (
      <div>
        <Modal
          open={this.state.showdeleteOrderModal}
          onClose={() => {
            this.state.showdeleteOrderModal = false;
            this.state.delete_order_ids = [];
            this.updateState();
          }}
          title="Delete Order"
        >
          <Modal.Section>
            <Stack vertical={true} alignment={"center"}>
              <Banner
                status={"warning"}
                title={
                  "Provide the Shopify Order ID of the order you want to delete. Please note that this process can't be reverted"
                }
              />
              <TextField
                key={"deleteOrderID"}
                value={this.state.delete_order_ids[0]}
                placeholder={"Provide order id for deletion..."}
                label={""}
                onChange={(e) => {
                  this.state.delete_order_ids[0] = e;
                  this.updateState();
                }}
              />
              <Button
                primary
                onClick={() => {
                  this.deleteOrderIds();
                }}
              >
                Delete Order
              </Button>
            </Stack>
          </Modal.Section>
        </Modal>
      </div>
    );
  }

  // handleTabChange(event) {
  //     //console.log(event);
  //     this.state.selectedTab = event;
  //     // this.state.AllSelect=(event===3 || event === 2)?true:false;
  //     if (event === 2 || event === 0 || event === 1) {
  //         this.state.visibleColumns = { 'check': 1, 'source_order_id': 1, 'shopify_order_name': 1, 'importedAt': 1, 'customer_name': 1, 'fulfillment': 1 };
  //         this.state.showMassAction = true;
  //         this.state.massAction = [
  //             // {label: 'Sync with Shopify', value: 'syncshopify'},
  //             { label: 'Sync shipment', value: 'syncshipment', disabled: false }
  //         ];
  //         if (event === 2) {
  //             this.state.massAction = [
  //                 // {label: 'Sync with Shopify', value: 'syncshopify'},
  //                 { label: 'Remove for app', value: 'removeorderapp', disabled: false },
  //                 { label: 'Sync shipment', value: 'syncshipment', disabled: false }
  //             ];
  //         }
  //     }
  //     else {
  //         this.state.visibleColumns = { 'source_order_id': 1, 'shopify_order_name': 1, 'importedAt': 1, 'customer_name': 1, 'fulfillment': 1 }
  //         this.state.massAction = [
  //             // {label: 'Sync with Shopify', value: 'syncshopify'},
  //             { label: 'Remove for app', value: 'removeorderapp', disabled: true },
  //             { label: 'Sync shipment', value: 'syncshipment', disabled: true }
  //         ];
  //     }

  //     this.state.showLoaderBar = false;
  //     this.state.rows = createDemoRows("", true, "Order_grid");
  //     this.state.pagination = {
  //         page: 1,
  //         totalNumberOfPages: 0,
  //         totalNumberOfProducts: 0,
  //         totalNumberOfItems: 0,
  //         pageSize: 25,
  //     }
  //     this.updateState();
  //     this.setState(this.state, () => {
  //         this.getOrders();
  //         this.setVisibleColumns();
  //     });

  // }

  orderSync() {
    requests
      .getRequest(
        "connector/order/sync",
        {
          marketplace: "ebay",
          target: "shopify",
          sync_order_from: this.state.sync_order_from,
        },
        false,
        true
      )
      .then((data) => {
        if (data.success) {
          if (data.code === "order_sync_started") {
            setTimeout(() => {
              this.redirect("/panel/activities");
            }, 500);
          }
          notify.success(data.message);
        } else {
          notify.error(data.message);
        }
        this.state.showSyncOrders = false;
        this.state.sync_order_from = "";
        this.updateState();
      });
  }

  setmodal(event, data) {
    this.state[event] = data;
    const state = this.state;
    this.setState(state);
  }

  getModalBody(data) {
    let temparr = [];
    switch (data) {
      case "syncwithShopify":
        temparr.push(
          <p>
            <h2>
              You have selected {this.state.selectedOrder.length}{" "}
              {this.state.selectedOrder.length > 1 ? "Orders" : "Order"}
            </h2>
            <h2>Do you want to Sync them with Shopify? </h2>
          </p>
        );
        break;
      case "removeorderapp":
        temparr.push(
          <p>
            <h2>
              You have selected {this.state.selectedOrder.length}{" "}
              {this.state.selectedOrder.length > 1 ? "Orders" : "Order"}
            </h2>
            <h2>Do you want to remove them from App? </h2>
          </p>
        );
        break;
      case "syncshipment":
        temparr.push(
          <p>
            <h2>
              You have selected {this.state.selectedOrder.length}{" "}
              {this.state.selectedOrder.length > 1 ? "Orders" : "Order"}
            </h2>
            <h2>Do you want to Sync their Status on App from Shopify?</h2>
          </p>
        );
        break;
    }
    return temparr;
  }

  renderModal(data) {
    console.log("data", data);
    return (
      <Modal
        open={this.state[data]}
        onClose={() => {
          this.setmodal(data, false);
        }}
      >
        <Modal.Section>
          <TextContainer>
            <Stack vertical={true} alignment={"center"}>
              {this.getModalBody(data)}
              <Stack vertical={false} alignment={"center"}>
                <Button
                  onClick={() => {
                    this.setmodal(data, false);
                  }}
                >
                  No
                </Button>
                <Button
                  primary={true}
                  loading={this.state.syncOrderShipmentBtnLoader}
                  onClick={() => {
                    this.hitModalfunction(data);
                  }}
                >
                  Yes
                </Button>
              </Stack>
            </Stack>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  hitModalfunction(data) {
    // console.log('data', data)
    switch (data) {
      case "syncwithShopify":
        this.syncProductconfirmed();
        break;
      case "removeorderapp":
        this.removeOrderApp();
        break;
      case "syncshipment":
        this.syncOrderShipment();
        break;
    }
  }

  getSourceShopId() {
    requests
      .getRequest(
        "connector/get/services",
        { "filters[type]": "importer" },
        false,
        true
      )
      .then((data) => {
        if (data.success === true) {
          this.setState({
            source_shop_id: data["data"]["shopify_importer"]["shops"][0]["id"],
          });
        } else {
          notify.error("Unable to get the shop Id");
        }
      });
  }
  syncProductconfirmed() {
    let final = [];
    // for (var key in this.state.checkbox) {
    //     final.push(key)
    // }
    /*let final=[];
        for(let i=0;i<this.state.tempOrderData.length;i++){
            this.state.tempSelectedProducts.forEach(function(item ,key){
                if(temp[i].source_order_id===item){
                    final.push(temp[i].source_order_id)
                }
            });
        }*/
    let { selectedOrder } = this.state;
    requests
      .postRequest("ebayV1/upload/selectAndSyncOrder", {
        order_ids: selectedOrder,
      })
      .then((data) => {
        if (data.success) {
          notify.success(data.message);
          if (data.code === "order_sync_started") {
            this.redirect("/panel/activities");
          }
        } else {
          notify.error(data.message);
        }
      });

    this.setmodal("syncwithShopify", false);
  }
  closesyncProductModal() {
    // this.state.topublishRow = {};
    this.state.syncwithShopify = false;
    const state = this.state;
    this.setState(state);
  }
  // pageSettingsChange(event) {
  //     this.gridSettings.count = event;
  //     this.gridSettings.activePage = 1;
  //     this.getOrders();
  // }

  // manageStateChange = (old_state) => {
  //     this.filters = Object.assign({}, old_state['filters']);
  //     this.gridSettings = Object.assign({}, old_state['gridSettings']);
  //     this.props.location.state = undefined;
  //     this.getOrders();
  // };

  //-----grid function-----------//

  allSelector(field, value) {
    if (value) {
      this.state.columns[0]["name"] = (
        <Checkbox
          id={"all"}
          checked={true}
          onChange={this.allSelector.bind(this, "all_selector")}
        />
      );
      this.state.tempOrderData.map((e) => {
        this.state.checkbox[e["source_order_id"]] = true;
      });
      this.state.massAction = [
        // {label: 'Sync with Shopify', value: 'syncshopify'},
        { label: "Remove for app", value: "removeorderapp" },
        { label: "Sync shipment", value: "syncshipment" },
      ];
      this.updateState();
      this.setState({
        rows: this.dataMapping(this.state.tempOrderData, false, "Order_grid"),
      });
    } else {
      this.state.columns[0]["name"] = (
        <Checkbox
          id={"all"}
          checked={false}
          onChange={this.allSelector.bind(this, "all_selector")}
        />
      );
      this.state.tempOrderData.map((e) => {
        if (e.source_order_id in this.state.checkbox) {
          delete this.state.checkbox[e.source_order_id];
        }
      });
      // if(Object.values(this.state.checkbox).length == 0){
      //   this.state.massAction = [];
      // }
      this.updateState();
      this.setState({
        rows: this.dataMapping(this.state.tempOrderData, false, "Order_grid"),
      });
    }
  }

  handleChangeCheck = (value, e) => {
    if (value) {
      this.state.checkbox[e] = value;
      let temp = 0;
      this.state.tempOrderData.map((e) => {
        if (e.source_order_id in this.state.checkbox) {
          temp += 1;
        }
      });

      if (
        temp == Object.keys(this.state.tempOrderData).length &&
        Object.keys(this.state.tempOrderData).length != 0
      ) {
        this.state.All_Selected = true;
      }
    } else {
      delete this.state.checkbox[e];
      this.state.All_Selected = false;
      // if(Object.values(this.state.checkbox).length == 0){
      //   this.state.massAction = [];
      // }
    }
    this.updateState();
    this.all_Selected();
    this.setState({
      rows: this.dataMapping(this.state.tempOrderData, false, "Order_grid"),
    });
  };

  prepareFilterObject(coloumn, index) {
    let filterObtained = "";
    if (coloumn !== "") {
      switch (coloumn) {
        case "shopify_order_name":
          filterObtained =
            index === undefined
              ? "filter[" + coloumn + "]"
              : "filter[" + coloumn + "][" + index + "]";
          break;
        case "source_order_id":
          filterObtained =
            index === undefined
              ? "filter[" + coloumn + "]"
              : "filter[" + coloumn + "][" + index + "]";
          break;
        case "customer_name":
          coloumn = "client_details.name";
          filterObtained =
            index === undefined
              ? "filter[" + coloumn + "]"
              : "filter[" + coloumn + "][" + index + "]";
          break;
        case "sandbox":
          filterObtained = "filter[" + coloumn + "][1]";
          break;
        case "failed":
          filterObtained =
            index === undefined
              ? "filter[" + coloumn + "]"
              : "filter[" + coloumn + "][" + index + "]";
          break;
        case "fulfillments":
          filterObtained =
            index === undefined
              ? "filter[" + coloumn + "]"
              : "filter[" + coloumn + "][" + index + "]";
          break;
        case "status":
          filterObtained =
            index === undefined
              ? "filter[" + coloumn + "]"
              : "filter[" + coloumn + "][" + index + "]";
          break;
      }
    }
    return filterObtained;
  }

  dataMapping(data, loading = "false", whichOne) {
    if (whichOne == "Order_grid") {
      return data.map((row) => {
        let data = {};
        data["check"] = (
          <div title={"checkbox"}>
            {" "}
            <Checkbox
              checked={
                this.state.checkbox.hasOwnProperty(row["source_order_id"])
                  ? true
                  : false
              }
              label={row["source_order_id"]}
              id={row["source_order_id"]}
              onChange={this.handleChangeCheck}
              labelHidden={true}
            />{" "}
          </div>
        );
        data["source_order_id"] = row["source_order_id"];
        data["shopify_order_name"] = !isUndefined(row["shopify_order_name"]) ? (
          <div title={"Order details"}>
            {row["shopify_order_name"]}
            <br /> Order ID -{" "}
            {!isUndefined(row["target_order_id"]) ? row["target_order_id"] : ""}
          </div>
        ) : (
          <div title={"Not available"}>
            <Icon source="subtract" />
          </div>
        );
        data["importedAt"] = row["imported_at"];
        data["customer_name"] =
          row.client_details.name !== "" ? (
            row.client_details.name
          ) : (
            <div title={"Not available"} className="w-100 text-center">
              <Icon source="subtract" />
            </div>
          );
        if (row["source_order_id"] !== "" && row["target_order_id"] === "") {
          row["status"] = "failed";
        }
        data["fulfillment"] = (
          <div title={"status"}>{this.getStatus(row["status"])}</div>
        );
        // data['extended_order_id'] =!isUndefined(row);
        if (!isUndefined(row.errors)) {
          data["errors"] = row.errors;
        }
        return data;
      });
    }
  }

  all_Selected() {
    if (this.state.All_Selected) {
      this.state.columns[0]["name"] = (
        <Checkbox
          id={"all"}
          checked={true}
          onChange={this.allSelector.bind(this, "all_selector")}
        />
      );
    } else {
      this.state.columns[0]["name"] = (
        <Checkbox
          id={"all"}
          checked={false}
          onChange={this.allSelector.bind(this, "all_selector")}
        />
      );
    }
    this.updateState();
  }

  setVisibleColumns() {
    let check = [];
    for (let key in this.column) {
      if (this.column[key]["key"] in this.state.visibleColumns) {
        check.push({ ...defaultData, ...this.column[key] });
      }
    }
    this.setState({ columns: check }, () => {
      //console.log(this.state.columns)
    });
  }

  getSubRowDetails = (expandedRows1) => (rowItem) => {
    let { expandedRows } = this.state;
    const isExpanded =
      expandedRows && expandedRows[rowItem.id]
        ? expandedRows[rowItem.id]
        : false;
    return {
      group: rowItem.variants && rowItem.variants.length > 0,
      expanded: isExpanded,
      children: rowItem.variants,
      field: "title",
      treeDepth: rowItem.treeDepth || 0,
      siblingIndex: rowItem.siblingIndex,
      numberSiblings: rowItem.numberSiblings,
    };
  };

  updateSubRowDetails(subRows, parentTreeDepth) {
    const treeDepth = parentTreeDepth || 0;
    subRows.forEach((sr, i) => {
      sr.treeDepth = treeDepth + 1;
      sr.siblingIndex = i;
      sr.numberSiblings = subRows.length;
    });
  }

  onCellExpand = (args) => {
    let { rows, expandedRows } = this.state;
    const rowKey = args.rowData.id;
    const rowIndex = rows.indexOf(args.rowData);
    const subRows = args.expandArgs.children;
    if (expandedRows && !expandedRows[rowKey]) {
      expandedRows[rowKey] = true;
      this.updateSubRowDetails(subRows, args.rowData.treeDepth);
      rows.splice(rowIndex + 1, 0, ...subRows);
    } else if (expandedRows[rowKey]) {
      expandedRows[rowKey] = false;
      rows.splice(rowIndex + 1, subRows.length);
    }
    this.setState({ expandedRows: expandedRows, rows: rows });
    return { expandedRows, rows };
  };

  // handleFilterChange = filter => {
  //     //console.log(filter);
  //     let { appliedFilters, preparedFilter } = this.state;
  //     preparedFilter[filter["key"]] = [this.prepareFilterObject(filter["key"], filter["operator"]), filter["rawValue"]];
  //     if (filter["rawValue"] === "") {
  //         delete preparedFilter[filter["key"]];
  //     }
  //     appliedFilters = {};
  //     this.setState({ preparedFilter, appliedFilters }, () => {
  //         for (let i in this.state.preparedFilter) {
  //             if (this.state.preparedFilter.hasOwnProperty(i)) {
  //                 appliedFilters[this.state.preparedFilter[i][0]] = this.state.preparedFilter[i][1];
  //             }
  //         }
  //         this.setState({ appliedFilters }, () => {
  //             this.getOrders();
  //         });
  //     });

  // };

  redirect(url, data) {
    /*if ( !isUndefined(data) ) {
            this.props.history.push(
                url,
                JSON.parse(JSON.stringify(data))
            );
        } else {
            this.props.history.push(url);
        }*/
    this.props.history.push(url);
  }

  getCellClick = (e) => {
    if (e.idx > 0 && this.state.selectedTab !== 2) {
      // this.redirect('/panel/orders/view?id=' + this.state.tempOrderData[e.rowIdx]["_id"]);
    } else if (this.state.selectedTab === 2 && e.idx > 0 && e.idx !== 3) {
      // this.redirect('/panel/orders/view?id=' + this.state.tempOrderData[e.rowIdx]["_id"]);
    }
    if (e.idx > 0 && this.state.selectedTab === 2) {
      switch (e.idx) {
        case 3:
          if (!isUndefined(this.state.tempOrderData[e.rowIdx]["errors"])) {
            this.setState({
              orderErrorJson: this.state.tempOrderData[e.rowIdx]["errors"],
              orderError: true,
            });
          }
          break;
      }
    }
  };

  // on Grid Update
  onGridRowsUpdated = (fieldName, fromRow, toRow, updated) => {
    //console.log(fieldName, fromRow, toRow, updated);
    this.setState((state) => {
      const rows = state.rows.slice();
      for (let i = fromRow; i <= toRow; i++) {
        rows[i] = { ...rows[i], ...updated };
      }
      return { rows };
    });
  };

  onHeaderDrop = (source, target) => {
    const stateCopy = Object.assign({}, this.state);
    const columnSourceIndex = this.state.columns.findIndex(
      (i) => i.key === source
    );
    const columnTargetIndex = this.state.columns.findIndex(
      (i) => i.key === target
    );

    stateCopy.columns.splice(
      columnTargetIndex,
      0,
      stateCopy.columns.splice(columnSourceIndex, 1)[0]
    );

    const emptyColumns = Object.assign({}, this.state, { columns: [] });
    this.setState(emptyColumns);

    const reorderedColumns = Object.assign({}, this.state, {
      columns: stateCopy.columns,
    });
    this.setState(reorderedColumns);
  };

  // set the Drop down Filter Value here
  getValidFilterValues = (rows, columnId) => {
    let val = rows
      .map((r) => r[columnId])
      .filter((item, i, a) => {
        return i === a.indexOf(item);
      });
    return val;
  };

  sortRows = (sortColumn, sortDirection) => {
    //console.log(sortColumn, sortDirection);
  };

  onCheckCellIsEditable = (event) => {
    // return false;
    let flag = true;
    if (event.row.variants && event.column.key !== "title") flag = false;
    if (event.row.type === "child" && event.column.key === "title")
      flag = false;
    return flag;
  };

  onRowsSelected = (rows) => {
    this.setState({
      selectedIndexes: this.state.selectedIndexes.concat(
        rows.map((r) => r.rowIdx)
      ),
      selectedOrderIds: this.state.selectedOrderIds.concat(
        rows.map((r) => r["row"]["source_order_id"])
      ),
    });
  };

  onRowsDeselected = (rows) => {
    let rowIndexes = rows.map((r) => r.rowIdx);
    let Ids = rows.map((r) => r["row"]["source_order_id"]);
    this.setState({
      selectedIndexes: this.state.selectedIndexes.filter(
        (i) => rowIndexes.indexOf(i) === -1
      ),
      selectedOrderIds: this.state.selectedOrderIds.filter(
        (i) => Ids.indexOf(i) === -1
      ),
    });
  };

  // handlePagination = (pageProps) => {
  //     this.setState({ pagination: pageProps }, () => {
  //         this.getOrders();
  //     });
  // };

  handleColumn = (columnProps) => {
    //console.log(columnProps);
    this.setState({ visibleColumns: columnProps }, () => {
      this.setVisibleColumns();
    });
  };

  // EmptyRowsView = () => {
  //     return (
  //         <EmptyState heading="No data found " action={{
  //             content: 'Refresh filter', onAction: () => {
  //                 this.setState({ appliedFilters: {} }, () => {
  //                     this.getOrders();
  //                 });
  //             }
  //         }} image="https://cdn.shopify.com/s/assets/admin/empty-states-fresh/emptystate-abandoncheckout-de95c7af243bfbc1a127a7bd1a6a9b7a5769ddc295a303268fdf26913f16801c.svg">
  //         </EmptyState>
  //     );
  // };

  performMassAction = (action) => {
    let tmp = [];
    let { selectedRows } = this.state;
    // for (var key in this.state.checkbox) {
    //     tmp.push(key)
    // }
    selectedRows.forEach((row) => {
      let { source_order_id } = row.customer_name.row;
      tmp.push(source_order_id);
    });
    this.setState({ selectedOrder: tmp }, () => {
      // console.log('selectedOrder', this.state.selectedOrder);
      if (this.state.selectedOrder.length > 0) {
        switch (action) {
          case "syncshopify":
            this.setmodal("syncwithShopify", true);
            break;
          case "removeorderapp":
            this.setmodal("removeorderapp", true);
            break;
          case "syncshipment":
            this.setmodal("syncshipment", true);
            break;
          default: //console.log(action,this.state.selectedProducts);
        }
      } else {
        notify.info("No product is selected");
      }
    });
  };

  removeOrderApp() {
    let final = [];
    // for (var key in this.state.checkbox) {
    //     final.push(key)
    // }
    let { selectedOrder } = this.state;
    requests
      .postRequest("ebayV1/delete/deleteOrderFromApp", {
        order_ids: selectedOrder,
      })
      .then((data) => {
        if (data.success) {
          notify.success(data.message);
        } else {
          notify.success(data.message);
        }
      });
    this.setmodal("removeorderapp", false);
  }

  syncOrderShipment() {
    let final = [];
    // for (var key in this.state.checkbox) {
    //     final.push(key)
    // }
    let { selectedOrder } = this.state;
    this.setState({ syncOrderShipmentBtnLoader: true });
    requests
      .postRequest("ebayV1/get/syncShipmentMultipleOrders", {
        order_ids: selectedOrder,
      })
      .then((data) => {
        if (data.success) {
          this.getOrdersNew();

          notify.info(data.message);
        } else {
          notify.info(data.message);
        }
        this.setmodal("syncshipment", false);
      });
    this.setState({ syncOrderShipmentBtnLoader: true });
  }

  getGridApi(api) {
    gridApi = api;
  }

  onPaginationChange(paginationProps) {
    this.setState({ paginationProps }, () => {
      this.getOrdersNew();
    });
  }

  async incellElement(field, data) {
    // console.log('selectedTab', this.state.selectedTab)
    let { _id, line_items } = data;
    switch (field) {
      case "edit":
        this.redirect("/panel/orders/view?id=" + _id);
      case "Failed":
        if (this.state.selectedTab === 2) {
          if (!isUndefined(data)) {
            this.setState({ orderErrorJson: data, orderError: true });
          }
        }
        break;
      case "":
        break;
    }
    // }
  }

  cellClickedEvent(colDef, data, rowIdx) {
    // let { field } = colDef;
    // if (this.state.selectedTab !== 2) {
    //     // this.redirect('/panel/orders/view?id=' + this.state.tempOrderData[rowIdx]["_id"]);
    // } else if (this.state.selectedTab === 2 && field !== "fulfillment") {
    //     // this.redirect('/panel/orders/view?id=' + this.state.tempOrderData[rowIdx]["_id"]);
    // }
    // if (this.state.selectedTab === 2) {
    //     switch (field) {
    //         case "fulfillment":
    //             console.log('object', this.state.tempOrderData[rowIdx]['errors'])
    //             if (!isUndefined(this.state.tempOrderData[rowIdx]['errors'])) {
    //                 // this.setState({ orderErrorJson: this.state.tempOrderData[rowIdx]['errors'], orderError: true })
    //             }
    //             break;
    //     }
    // }
  }

  // utkarsh

  prepareFilters() {
    let { filtersProps } = this.state;
    filtersProps["attributeoptions"] = [
      ...prepareChoiceoption(filterOptions, "headerName", "field"),
    ];
    this.setState({ filtersProps });
  }

  async getOrdersNew() {
    // this.toggleOverLay(true);
    this.grid_loader = true;
    this.updateState();
    let {
      paginationProps,
      tabfilters,
      filtersProps,
      // user_idAG
    } = this.state;
    let { filters } = filtersProps;
    let { pageSize: count, activePage } = paginationProps;
    // let sortingOrdering = {
    //     sort: this.state.sortby !== '' ? this.state.sortby : false,
    //     order: this.state.high_low_sort !== '' ? this.state.high_low_sort : false
    // }
    let ordersRequest = await getorders({
      count,
      activePage,
      ...tabfilters,
      ...getFilterforRequest(filters),
    });
    let { success, data, user_id } = ordersRequest;
    if (success) {
      // user_idAG = user_id;
      let { rows, count: totalRecords } = data;
      let paginationInformation = getpaginationInfo(totalRecords, count);
      paginationProps = { ...paginationProps, ...paginationInformation };
      let extractRowData = extractValuesfromRequest(rows);
      this.state.rawData = rows;
      this.setState({
        rowsAG: [...extractRowData],
        paginationProps,
        tempOrderData: rows,
        // user_idAG
      });
      this.grid_loader = false;
      this.updateState();
    }
    // this.toggleOverLay(false);
  }

  filterData(componentFilters) {
    this.setState({ selectedRows: [] });
    let { filtersProps } = this.state;
    filtersProps["filters"] = [...componentFilters];
    this.setState({ filtersProps }, () => {
      this.getOrdersNew();
    });
  }

  getSelectedRows(selectedRows) {
    this.setState({ selectedRows });
  }
  render() {
    let {
      tabs,
      columnsAG,
      rowsAG,
      selectedTab,
      paginationProps,
      filtersProps,
      selectedRows,
    } = this.state;
    return (
      <Page
        fullWidth={true}
        titleMetadata={
          <Stack vertical={false}>
            {/* <p style={{ cursor: 'pointer' }} onClick={() => {
                    window.open('https://docs.cedcommerce.com/shopify/ebay-marketplace-integration/?section=orders-28', '_blank')
                    }}><Badge status={"info"}><b style={{ color: '#0000aa', textDecoration: 'underline' }}>Need help?</b></Badge></p> */}
            <Badge status={"new"}>
              {`${this.state.credits_info.order.available} / ${this.state.credits_info.order.total} order credits available`}
              <Tooltip content="1 Order credit means 1 eBay Order can be managed from Shopify through the app">
                <Icon source={QuestionMarkMinor} />
              </Tooltip>
            </Badge>
          </Stack>
        }
        title="Orders"
        secondaryActions={[
          {
            content: (
              <Badge status={"info"}>
                <b>Delete shopify order</b>
              </Badge>
            ),
            // content: <Button  size="slim">Delete shopify order</Button>,
            onAction: () => {
              this.state.showdeleteOrderModal = true;
              this.updateState();
            },
          },
        ]}
        primaryAction={{
          content: "Import eBay order(s)",
          onAction: () => {
            this.state.showSyncOrders = true;
            this.updateState();
          },
        }}
      >
        <div className="mb-4">
          {/*{this.state.isSandbox?<Banner status={"warning"}>*/}
          {/*<h5>*/}
          {/*Default mode for Order Syncing is Sandbox mode currently. You can change it*/}
          {/*<NavLink to={'/panel/configuration'}> here</NavLink>.*/}
          {/*</h5>*/}
          {/*</Banner>:null}*/}
          <Stack vertical={true} spacing={"loose"}>
            <Stack.Item>
              {/* <Banner title={`${this.state.credits_info.order.available} / ${this.state.credits_info.order.total} order credits available`} />
                            <ProgressBar progress={this.state.credits_info.order.percent} size="small" /> */}
            </Stack.Item>
            <Banner status={"info"}>
              <li>
                New Order(s), whose payment has been done, is synced from eBay
                to Shopify within 60 minutes.
              </li>
              <li>
                For syncing old order(s){" "}
                <span
                  style={{ color: "#0000FF", cursor: "pointer" }}
                  onClick={() => {
                    this.redirect("/panel/help/report");
                  }}
                >
                  contact us
                </span>
                .
              </li>
              <li>
                It is recommended that sellers must fulfill orders after 1 hour
                of their creation.
              </li>
              {this.state.selectedTab === 2 ? (
                <li>
                  Click on the Failed badge of the order to view the error.
                </li>
              ) : null}
            </Banner>
          </Stack>
        </div>

        <LoadingOverlay
          active={this.grid_loader}
          spinner
          text="Loading please wait..."
        >
          <Grid
            tag={"Order(s)"}
            showTabs={true}
            tabs={tabs}
            selectedTab={selectedTab}
            tabSelected={this.tabSelected.bind(this)}
            columns={columnsAG}
            rows={rowsAG}
            showFilters
            customRowHeight={40}
            filterData={this.filterData.bind(this)}
            filtersProps={filtersProps}
            // selectedActions={selectedActions}
            // onSelectAction={this.onSelectedAction.bind(this)}
            getGridApi={this.getGridApi.bind(this)}
            paginationProps={paginationProps}
            onpaginationChange={this.onPaginationChange.bind(this)}
            // suppressSizeToFit={true}
            suppressMovableColumns={true}
            suppressRowClickSelection={true}
            enableCellTextSelection={true}
            rowSelection={"multiple"}
            selectedRows={selectedRows}
            cellClickedEvent={this.cellClickedEvent.bind(this)}
            rowSelected={this.getSelectedRows.bind(this)}
            massAction={this.state.massAction}
            suffix={this.state.toolbar_suffix}
            performMassAction={this.performMassAction}
            frameworkComponents={this.state.frameworkComponents}
            noRowsOverlayComponent={this.state.noRowsOverlayComponent}
            noRowsOverlayComponentParams={
              this.state.noRowsOverlayComponentParams
            }
          />
        </LoadingOverlay>
        {this.state.orderError && this.OrderErrorModal()}
        {this.state.showdeleteOrderModal && this.renderdeleteOrderIdsModal()}
        {this.renderSyncOrderModal()}
        {this.state.syncwithShopify && this.renderModal("syncwithShopify")}
        {this.state.removeorderapp && this.renderModal("removeorderapp")}
        {this.state.syncshipment && this.renderModal("syncshipment")}
        <FooterHelp>
          Learn more about{" "}
          <Link
            external
            url="https://docs.cedcommerce.com/shopify/ebay-marketplace-integration/?section=orders-28"
          >
            Orders
          </Link>
        </FooterHelp>
      </Page>
    );
  }

  OrderErrorModal() {
    let msg = "";
    Object.keys(this.state.orderErrorJson).map((e) => {
      // console.log(e);
    });
    if (this.state.orderErrorJson["message"] !== undefined) {
      msg = this.state.orderErrorJson["message"].replace("sku", "SKU");
    }
    return this.state.orderErrorJson["message"] &&
      this.state.orderErrorJson["message"] ===
        "Product is either not uploaded from app or title and sku did not match else does not exists" ? (
      <Modal
        title={<p>Order ID : {ebayId}(Shopify response)</p>}
        open={this.state.orderError}
        onClose={() => {
          this.setState({ orderErrorJson: false, orderError: false });
        }}
      >
        <Modal.Section>
          {/* <ReactJson style={{ maxHeight: 200, overflowY: 'scroll' }} src={this.state.orderErrorJson} /> */}
          <Banner title={msg} status="critical">
            <br />
            <p>
              <Subheading>Cause :</Subheading>The ordered product is unavailable
              in app.
            </p>
            <br />
            <Subheading>How to remove the error?</Subheading>
            <br />

            <p>
              {" "}
              <b>When the product is available in your Shopify store : </b>
            </p>
            <p>
              {" "}
              Use the same Title or SKU on both platforms (Shopify & eBay) as
              the app maps eBay and Shopify attributes (Title or SKU) of already
              existing eBay products.
            </p>

            <br />

            <p>
              <b>When the product is not available in your Shopify store : </b>
            </p>
            <p>Create the product with the exact Title & SKU as eBay.</p>
            <br />
            <p>
              Once the above-mentioned rectifying steps have been performed,
              delete the order from the app. The order will get synced within a
              few minutes.
            </p>
            <br />
          </Banner>
        </Modal.Section>
      </Modal>
    ) : this.state.orderErrorJson["line_items"] &&
      this.state.orderErrorJson["line_items"][0] &&
      this.state.orderErrorJson["line_items"][0] ===
        "Unable to reserve inventory" ? (
      <Modal
        title={<p>Order ID : {ebayId}(Shopify response)</p>}
        open={this.state.orderError}
        onClose={() => {
          this.setState({ orderErrorJson: false, orderError: false });
        }}
      >
        <Modal.Section>
          <Banner
            title={this.state.orderErrorJson["line_items"][0]}
            status="critical"
          >
            {console.log("here0")}
            <br />
            <p>
              <Subheading>Cause :</Subheading>This response means that the
              ordered product doesn't contain stock/ inventory in Shopify.
            </p>
            <br />
            <Subheading>How to remove the error?</Subheading>

            <p>
              Update the stock in Shopify for the ordered product. Once updated,
              delete the order from the app, and click on the
              <b> Import eBay Orders </b>button.
            </p>
          </Banner>
        </Modal.Section>
      </Modal>
    ) : (
      // (this.state.orderErrorJson["customer"] &&
      //     this.state.orderErrorJson["customer"][0] &&
      //     this.state.orderErrorJson["customer"][0] ===
      //       "Email contains an invalid domain name") ||
      //   this.state.orderErrorJson["customer"][0] ===
      //     "Email has already been taken" ? (
      //   <Modal
      //     title={<p>Order ID : {ebayId}(Shopify response)</p>}
      //     open={this.state.orderError}
      //     onClose={() => {
      //       this.setState({ orderErrorJson: false, orderError: false });
      //     }}
      //   >
      //     <Modal.Section>
      //       {/* <ReactJson style={{ maxHeight: 200, overflowY: 'scroll' }} src={this.state.orderErrorJson} /> */}
      //       <Banner
      //         title={this.state.orderErrorJson["customer"][0]}
      //         status="critical"
      //       >
      //         <br />
      //         <p>
      //           <Subheading>Cause :</Subheading>The email ID provided by the buyer
      //           does not have a valid domain.
      //         </p>
      //         <br />
      //         <Subheading>How to remove the error?</Subheading>
      //         You need to go to, Configuration section >> Seller Preference >>
      //         RESOLVE ORDER AND EMAIL ERROR (The option helps resolve the email
      //         error of orders.) Once there, click on the Add option. You need to
      //         enter the Order ID (use the order ID for which you want to create
      //         the order) and the Email (Enter the email you want to use for the
      //         order.)
      //       </Banner>
      //     </Modal.Section>
      //   </Modal>
      // ) :
      <Modal
        title={<p>Order ID : {ebayId}(Shopify response)</p>}
        open={this.state.orderError}
        onClose={() => {
          this.setState({ orderErrorJson: false, orderError: false });
        }}
      >
        <Modal.Section>
          {typeof(this.state.orderErrorJson) === 'string' ? 
          <Banner
            title={`${this.state.orderErrorJson} For more details please contact our support team.`}
            status="critical"
          />
          :
          <ReactJson
            style={{ maxHeight: 200, overflowY: "scroll" }}
            src={this.state.orderErrorJson}
          />
          }
        </Modal.Section>
      </Modal>
    );
  }
  redirect(url, data) {
    if (!isUndefined(data)) {
      this.props.history.push(url, JSON.parse(JSON.stringify(data)));
    } else {
      this.props.history.push(url);
    }
  }
}

export default NewOrders;
